export default __webpack_public_path__ + "static/media/gear.c3e9dee6.svg";